<template>
    <div class="container maxsize" id="mainContainer">
        <br class="my-4">
        <h1 class="subtitle"><span class="firstletter">D</span>NA <span class="firstletter">P</span>rotein <span class="firstletter">I</span>nto <span class="firstletter">M</span>usic</h1>
        <hr class="my-4">
        <div class="form-group">
            <label for="inputSequence" class="lead"><span class="firstletter">Insert</span> DNA Sequence</label>
            <textarea v-model="sequence" type="textarea" class="form-control"
                id="inputSequence" :rows="showAdvanced ? 6 : 8" placeholder="Example: ATCG"></textarea>
            <small class="form-text text-muted">Accepts uppercase or lowercase letters. Invalid characters (which do not represent a nucleotide) will be played as pauses.</small>
        </div>
        <!-- <hr class="my-4">
        <div class="container-fluid" v-show="musicSheet['visible']">
            <div class="container-fluid" id="musicSheetContainer">
            </div>
            <hr class="my-4">
        </div> -->
        <div class="row">
            <div class="col-sm">
                <div class="form-group">
                    <label for="inputInstrument" class="lead"><span class="firstletter">Choose</span> Instrument</label>
                    <select v-model="selectedInstrument" class="form-control" id="inputInstrument">
                        <option v-for="option in instruments" v-bind:value="option" :key="option">
                            {{ option }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-sm">
                <div class="form-group">
                    <label for="tempo" class="lead"><span class="firstletter">Set</span> Tempo</label>
                    <input v-model="tempo" type="number" step="0.05" class="form-control">
                    <small class="form-text text-muted">Seconds between chords.</small>
                </div>
            </div>
            <!-- <div class="col-sm" v-if="showAdvanced">
                <div class="form-group">
                    <label for="tempo" class="lead"><span class="firstletter">Customizar</span> Ritmo</label>
                    <input v-model="tempo" type="number" step="0.1" class="form-control">
                    <small class="form-text text-muted">Segundos entre notas.</small>
                </div>
            </div> -->
        </div>
        <div class="d-flex flex-row-reverse playbuttons">
            <!-- <button type="button" class="btn btn-light" v-if="showAdvanced"
                @click="viewSheet" id="createbutton"><span v-if="!musicSheet['visible']">Mostrar</span><span v-else>Ocultar</span> Partitura</button> -->
            <button type="button" class="btn btn-outline-info"
            @click="clearSequence" id="clearbutton">Clear</button>
            &nbsp;
            <button type="button" class="btn btn-danger"
            @click="stopSong" id="stopbutton" :disabled="!audioLoaded">Stop</button>
            &nbsp;
            <button type="button" class="btn btn-primary"
            @click="playSong" id="playbutton" :disabled="!audioLoaded">Play</button>
            &nbsp;
        </div>
        <!-- <div v-if="showAdvanced">
            <hr class="my-4">
            <div class="form-group" id="chords-selection">
                <label for="chordsSelection" class="lead"><span class="firstletter">Afine</span> os Nucleotídeos</label>
                <div class="container-fluid">
                    <div v-for="nucleotide in nucleotides" class="inline-select" :key="nucleotide.shortName">
                        {{nucleotide.fullName}}
                        <select :value="nucleosToChords[nucleotide.value]"
                                @change="($event) => updateSelected($event, nucleotide.value)"
                        >
                            <option v-for="chord in chords" v-bind:value="note" :key="chord">
                                {{ note }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="clearfix"></div>
            <br>
            <button type="button" class="btn btn-light"
            @click="resetTuning" id="playbutton">Resetar Afinação</button>
        </div> -->
    </div>
</template>

<script>
import { SampleLibrary } from '../libraries/Tonejs-instruments'
import * as Tone from 'tone'
// import Vex from 'vexflow';
import { serverBus }  from '../main'

const nucleotides = [
  {fullName: "adenine (A)      ", shortName: "ade", value: "A", baseNote: "A6"},
  {fullName: "cytosine (C)     ", shortName: "cyt", value: "C", baseNote: "C6"},
  {fullName: "guanine (G)      ", shortName: "gua", value: "G", baseNote: "G6"},
  {fullName: "thymine (T)      ", shortName: "thy", value: "T", baseNote: "B6"},
]

const nucleosToChordsOriginal = {
    "A": "A6", "C": "C6", "T": "B6", "G": "G6"
}

const chords = [
  "A6", "C6", "G6", "B6",
]

const enzymesToNotes = {
    EcoRI: ['C4', 'E4', 'G4'],
    HindIII: ['D4', 'F4', 'A4'],
    BamHI: ['E4', 'G4', 'B4'],
    NcoI: ['F4', 'A4', 'C4'],
}

const enzymes = {
  GAATTC: 'EcoRI',
  AAGCTT: 'HindIII',
  GGATCC: 'BamHI',
  CCATGG: 'NcoI'
};


// var exampleSequence = "CCCCC(420)-CCWHC(117)-WCCCC(72)-YCCCC(66)-CWCFW(64)-CHWCH(51)-WCWCF(49)-CCCCY(46)-CWCCC(38)-YWCWC(37)-CCHCC(35)-WCCHC(30)-CYCCC(29)-WWWDC(26)"

// basic default export
export default {
    name: 'Dna',
    methods: {
        printSequence: function () {
            // retorno: o html para ser inserido na pagina
            // criar o html
            // a partir da sequencia principal, e trocar subsequencias pela notação correspondente
            // deixar subsequencias em italico
            // negritar os trechos correspondentes a ilhas
        },
        playSong: function() {

            console.log("Playing a new sequence")
            var seqString = this.sequence.toUpperCase()
            this.audioLoaded = true
            this.instrumentsTone[this.selectedInstrument].toMaster();

            // added: get CPG markers
            var cpgMarkers = this.getCPGMarkers(seqString)
            console.log(cpgMarkers)

            //added: add enzymes
            seqString = this.addEnzymes(seqString)
            console.log(seqString)

            //stop any previous song before proceeding
            this.stopSong()

            var timing = 0
            var j = 0 // controla o loop sobre so aminoacidos apenas
            var cpgTimeMarkers = []
            var lastMarkerSeen = 0
            for (var i=0; i<seqString.length; i++) {
                // guarda os timings para chamar a camada CPG depois
                if (j === cpgMarkers[lastMarkerSeen]) {
                    cpgTimeMarkers.push(timing)
                    lastMarkerSeen++
                }
                var str = seqString[i]
                // se nucleo, toca acorde
                if (str.length == 1 && str in this.nucleosToChords) {
                    var chord = this.nucleosToChords[str]
                    console.log(chord)
                    this.setMusicDelay(chord, this.tempo, timing)
                    timing += this.tempo
                    j++
                }
                // caso contrario, toca arpejo
                else if (str.length > 1 && str in enzymesToNotes)  {
                    var notes = enzymesToNotes[str]
                    for (var note in notes) {
                        this.setMusicDelay(notes[note], this.tempoEnzymes, timing)
                        timing += this.tempoEnzymes
                    }
                }
            }
            // adiciona Camada
            console.log(cpgTimeMarkers)
            for (var k=0; k<cpgTimeMarkers.length; k+=2) {
                // markers estão sempre em pares, começo e final
                var timeDiff = cpgTimeMarkers[k+1] - cpgTimeMarkers[k]
                var initialTime = cpgTimeMarkers[k]
                // número de notas a tocar vai depender to tempo definido para a nota da camada
                var numNotes = timeDiff / this.tempoCPG
                for (var n=0; n<numNotes; n++) {
                    var noteToPlay = this.listaCamada[n % this.listaCamada.length]
                    this.setMusicDelay(noteToPlay, this.tempo, initialTime + n*this.tempoCPG)
                }
            }
            Tone.Transport.start()
        },
        setMusicDelay: function(note, tempo, relativeTime) {
            Tone.Transport.schedule((time) => {
                this.instrumentsTone[this.selectedInstrument].triggerAttackRelease(note, tempo, time)
            }, relativeTime)
        },
        stopSong: function() {
            // Stop, rewind and clear all events from the transport (from previous plays)
            Tone.Transport.stop();
            Tone.Transport.position = 0;
            Tone.Transport.cancel();
        },
        clearSequence: function() {
            console.log("Clearing the sequence")
            this.sequence = "";
        },
        resetTuning: function() {
            this.nucleosToChords = nucleosToChordsOriginal
        },
        updateSelected: function(event, nucleotide) {
            var chord = event.target.value
            console.log("Changing: ", nucleotide, chord)
            this.nucleosToChords[nucleotide] = chord
        },
        addEnzymes: function(input) {
            input = input.toUpperCase()
            var modInput = []
            for (let i = 0; i < input.length ; i++) {
                if (i <= (input.length - 5)) {
                    const substring = input.slice(i, i + 6)
                    if(enzymes[substring]){
                        modInput.push(enzymes[substring])
                    }
                }
                modInput.push(input[i])
            }
            return modInput;
        },
        getCPGMarkers: function (input) {
            var count = {'A':0, 'T':0, 'C':0, 'G':0, 'CG': 0}
            var markers = []
            var windowActive = false
            for (let i =0; i < input.length; i++) {
                // update counters up
                count[input[i]] += 1
                if (i >= 1 && input.slice(i-1,i+1) == 'CG') {
                    count['CG'] += 1
                }
                // update counters down, after window
                if (i >= 500) {
                    count[input[i-500]] -= 1
                    if (input.slice(i-500, i-498) == 'CG') {
                        count['CG'] -= 1
                    }
                }
                // verify if is a CPG island
                if (i >= 499) {
                    var gcContent = (count['G'] + count['C']) / (count['A'] + count['T'])
                    var gcExpected = (count['CG'] * 500) / (count['G'] * count['C'])
                    // push marker for beginning and end of sequences
                    // para alterar quando tocar a ilha, modificar o cálculo abaixo
                    if (gcContent >= 0.55 && gcExpected >= 0.65) {
                        if (!windowActive) {
                            windowActive = true
                            markers.push(i-499)
                        }
                    } else {
                        if (windowActive) {
                            windowActive = false
                            markers.push(i)
                        }
                    }
                }
            }
            //close last open sequence, if it goes all the way to end of input
            if (markers.length % 2 != 0) {
                markers.push(input.length-1)
            }
            return markers
        },
    },
    data () {
        return {
            publicPath: process.env.BASE_URL,
            projectAcronym: "DPIM",
            projectName: "DNA Protein Into Music",
            sequence: "",
            visibleSequence: "",
            tempo: 0.25,
            selectedInstrument: "Soft Piano",
            instruments: [
                "Acoustic Guitar", "Bebop Organ", "Celtic Harp", "Peel Guitar", "Soft Piano",
            ],
            nucleotides: nucleotides,
            chords: chords,
            musicSheet: {
                "created": false,
                "visible": false
            },
            nucleosToChords: {
                "A": "A6", "C": "C6", "T": "B6", "G": "G6",
            },
            enzymesToNotes: {
                EcoRI: ['C4', 'E4', 'G4'],
                HindIII: ['D4', 'F4', 'A4'],
                BamHI: ['E4', 'G4', 'B4'],
                NcoI: ['F4', 'A4', 'C4'],
            },
            listaCamada: ['1','1','1','2','2','2','3','3','3','4','4','4'],
            showAdvanced: serverBus.showAdvanced,
            audioLoaded: false,
            instrumentsTone: null,
        }
    },
    created() {
        // // Using the server bus to listen to option changes
        // serverBus.$on('advancedOptions', (selectedOption) => {
        //     this.showAdvanced = selectedOption
        //         console.log('listening', this.showAdvanced)
        // })
        // code to disable the buttons - temporarily disabled
        // moved from created
        this.instrumentsTone = SampleLibrary.load({
            instruments: this.instruments,
            ext: ".[wav|mp3|ogg]",
            baseUrl: "tonejs-instruments/samples/"
            // baseUrl: "https://musical-proteins.web.app/tonejs-instruments/samples/"
        })
        Tone.Buffer.on('load', () => {
            console.log('loaded tunes')
            this.audioLoaded = true
        })
    },
    // ready() {
    //     console.log('running')
    //     Tone.Buffer.on('load', () => {
    //         this.audioLoaded = true
    //     })
    // }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@font-face { font-family: Dosis; src: url('../assets/Dosis-Light.ttf'); }
.title {
        font-family: "Open Sans"
}
.subtitle {
     font-family: Dosis;
     color: #bbbbbb;
     font-size: 60px;
     text-align: center;
}
.firstletter {
        font-weight: 700;
        color: #007bff;
}
.inline-select {
        display: inline;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-right: 5px;
        padding-left: 5px;
        text-align: right;
        font-family: "PT Sans Narrow";
}
#chords-selection{
    min-height: 250px;
}
.align-right{
        text-align: right;
}
.clearfix {
     overflow: auto;
}
.clearfix::after {
    content: "";
    clear: both;
    display: table;
}
.maxsize {
    margin-right: auto;
    margin-left: auto;
    max-width: 992px; /* or 950px */
}
#musicSheetContainer {
    overflow: scroll;
}
/* #createbutton {
    padding-right: 100px;
    margin-right: 100px;
} */
/* #playbutton {
    padding-left: 100px;
    margin-left: 100px;
} */

.playbuttons button {
    margin-right: 5px;
}
</style>
